import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import RightMenu from "../RightMenu";
import CalendarButton from "../CalendarButton";
import Dropdown from "../Dropdown";
import RightIconMenu from "../RightIconMenu";
import AudioPlayer from "react-custom-audio-player";
// import ScriptTag from 'react-script-tag';
import mobile from '../../Helpers/'
import CustomCarousel from "../CustomCarousel"

export default class View_type_5 extends Component {
	constructor(props) {
		super(props);

		var data = {
			list: [],
			title: "",
			right_description: "",
			calendar: [],
			right_menu: [],
			prev_dropdown: [],
			tabs: [],
			...props.data
		};
		this.state = {
			data: data,
			r_menu: data.right_menu ? data.right_menu : [],
			rightMenu: data.right_menu ? data.right_menu : [],
			tabs: data.tabs,
			calendar: data.calendar,
			prevDropdown: data.prev_dropdown ? data.prev_dropdown : [],
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],
		}
	}

	createMarkup(item) {
		return { __html: item };
	}

	// For every image in .vt5.list_text class add eventListener with customLightbox function
	componentDidMount() {
		document.querySelectorAll(".vt5.list_text img").forEach(e => e.addEventListener("click", this.customLightbox.bind(null, e)))
	}

	// Create customLightbox
	customLightbox(e) {
		// Create image
		const imageSrc = e.getAttribute("src");
		const image = document.createElement("img");
		image.setAttribute("src", imageSrc);

		// Create gallery and add image to it
		const customGallery = document.createElement("div");
		customGallery.classList.add("custom-lightbox");
		customGallery.appendChild(image);
		document.body.appendChild(customGallery);

		// Remove customLightbox
		customGallery.addEventListener("click", function (f) { f.currentTarget.remove() });
	}



	render() {
		var title = this.state.data.title;
		var right_description = this.state.data.right_description;
		var _this = this;

		return (
			<div className={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length > 5 ? 'vt10 vt10--flex-nav' : 'vt5'}`}>

				<div className={`vt5 left col-xs-12 col-sm-12 col-md-9 col-lg-9`}>
					<div className={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length > 5 ? 'vt5 mobile-menu-vt5' : 'vt5 mobile-menu-vt5'}`}>

						{this.state.calendar.length ? <CalendarButton data={this.state.calendar} /> : null}
						{/* {this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown giveMeClassName={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length > 5 ? 'festiwal--dropdown' : 'normal'}`} data={this.state.prevDropdown} /> : null} */}
						{this.state.rightMenu.length ? <RightMenu data={this.state.rightMenu} /> : null}


					</div>
					<div className="vt5 title">
						{this.state.prevDropdown && this.state.prevDropdown.dates ? (
							<div className="custom-carousel-wrapper">
								<CustomCarousel data={this.state.prevDropdown} />
							</div>
						) : null}
						<div
							className="vt5 title-name artists-pageTitle"
							dangerouslySetInnerHTML={{ __html: title }}
						/>

						<div className="vt5 title-tabs">
							{this.state.tabs.map(function (object, i) {
								if (object.active == 1) {
									return (
										<div
											className="vt5 col-xs-6 col-sm-6 col-md-6 col-lg-6"
											key={i}
										>
											<div className="vt5 tab-checked">
												<Link to={"/" + object.link}>{object.title}</Link>
											</div>
										</div>
									);
								} else {
									return (
										<div
											className="vt5 col-xs-6 col-sm-6 col-md-6 col-lg-6"
											key={i}
										>
											<Link to={"/" + object.link}>{object.title}</Link>
										</div>
									);
								}
							})}

						</div>
					</div>
					<div>
						{this.state.data.list.map(function (object, i) {

							var color = object.backgroundColor;
							var img = object.img;
							const desc = object.dedication ? object.dedication : null;
							console.log(object);
							if (
								object !== "undefined" &&
								object.hasOwnProperty("img") &&
								object.hasOwnProperty("title")
							) {
								var thumbnail = (
									<div
										style={{
											flex: 1,
											backgroundColor: color,
											padding: 10,
											color: "white",
											position: "absolute",
											left: 15,
											right: 15
										}}
									>
										{object.title}
									</div>
								);
								return (
									<div className="vt5 content" key={i}>
										<div>
											{thumbnail}
											{object.img ? <img src={object.img} className="vt5 list_image" alt={object.name} /> : null}

											{object.time_of_life ? (
												<div
													className="custom-text-1"
													dangerouslySetInnerHTML={_this.createMarkup(
														object.time_of_life
													)}
												/>
											) : null}
											<div
												className="vt5 list_text"
												dangerouslySetInnerHTML={_this.createMarkup(
													object.text
												)}
											/>
											<div
												className="vt5 list_text dedication-box"
												dangerouslySetInnerHTML={_this.createMarkup(desc)}
											/>
										</div>
									</div>
								);
							} else {
								return (
									<div className="vt5 content margin-fix" key={i}>
										<div>
											{img ?
												(<img src={img} className="vt5 list_image" alt={img.split('/').pop().replace(/(\.(jpg|jpeg|png|gif))+$/gi, '')} />)
												:
												(null)

											}
											{object.time_of_life ? (
												<div
													className="custom-text-1"
													dangerouslySetInnerHTML={_this.createMarkup(
														object.time_of_life
													)}
												/>
											) : null}


											<div
												className="vt5 list_text"
												dangerouslySetInnerHTML={_this.createMarkup(
													object.text
												)}
											/>
											<div
												className="vt5 list_text dedication-box"
												dangerouslySetInnerHTML={_this.createMarkup(desc)}
											/>

										</div>
									</div>
								);
							}

						})}

					</div>
					<div className="mobile-audio">
						{this.state.data.play_audio_text && this.state.data.audio_list ? <h3 className="audio-text">{this.state.data.play_audio_text}</h3> : null}
						{this.state.data.audio_list ? (
							this.state.data.audio_list.map((item, index) => {
								return (
									<div className="right-audio-wrapper">
										<h3 className="audio-title" dangerouslySetInnerHTML={{ __html: item.title }}></h3>
										<span className="audio__wrapper">
											<AudioPlayer
												controls={true}
												src={item.mp3_url}
											/>
										</span>
										<h4 className="performer" dangerouslySetInnerHTML={{ __html: item.text ? item.text : null }} />
									</div>
								)
							})
						) : null}
					</div>
				</div>
				<div className={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length > 5 ? 'vt5 right asd col-xs-3 col-sm-3 col-md-3 col-lg-3 dropdown--nav-flex' : 'vt5 right col-xs-3 col-sm-3 col-md-3 col-lg-3'}`}>

					{this.state.calendar.length ? <CalendarButton data={this.state.calendar} /> : null}
					{/* {this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown giveMeClassName={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length > 5 ? 'festiwal--dropdown' : 'normal'}`} data={this.state.prevDropdown} /> : null} */}
					{this.state.rightMenu.length ? <RightMenu data={this.state.rightMenu} /> : null}
					{this.state.data.audio ?
						(<div className="right-audio-wrapper">
							<h3 className="audio-text">{this.state.data.play_audio_text}</h3>
							<h3 className="audio-title" dangerouslySetInnerHTML={{ __html: this.state.data.title }}></h3>
							<span className="audio__wrapper">
								<AudioPlayer
									controls={true}
									src={this.state.data.audio}
								/>
							</span>
							<h4 className="performer">{this.state.data.play_audio_performers ? this.state.data.play_audio_performers : null}</h4>
						</div>
						)
						:
						(null)}

					{this.state.data.play_audio_text && this.state.data.audio_list ? <h3 className="audio-text">{this.state.data.play_audio_text}</h3> : null}
					{this.state.data.audio_list ? (
						this.state.data.audio_list.map((item, index) => {
							return (
								<div className="right-audio-wrapper">
									<h3 className="audio-title" dangerouslySetInnerHTML={{ __html: item.title }}></h3>
									<span className="audio__wrapper">
										<AudioPlayer
											controls={true}
											src={item.mp3_url}
										/>
									</span>
									<h4 className="performer" dangerouslySetInnerHTML={{ __html: item.text ? item.text : null }} />
								</div>
							)
						})
					) : null}
				</div>

			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_5/index.js